import { createAction } from '@reduxjs/toolkit';

export const rustoreSnackbarShow = createAction<{ isFolder: boolean }>('rustoreSnackbar/show');
export const rustoreSnackbarCancel = createAction('rustoreSnackbar/cancel');
